export const packageCruiseEnabled = (countryCode: string) => {
    return ['de', 'c1uk', 'c1au'].includes(countryCode);
};
